import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import '@css/side-bar-layout.css'
import {
    Sidebar,
    Menu,
    MenuItem,
    SubMenu
} from 'react-pro-sidebar';
import newLogo from "@images/MainLogo_crop.png";
import miniLogo from "@images/yuldo-mini-logo.png";
import 'boxicons/css/boxicons.min.css';
import SubMenuItem from "./SubMenuItem";
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as BiIcons from 'react-icons/bi';
import * as GiIcons from 'react-icons/gi';
import * as BsIcons from "react-icons/bs";
import { useDispatch } from 'react-redux';
import { addTab } from '@store/tabSlice';
import axiosInstance from '@utils/axiosInstance';


const getIconComponent = (iconName) => {
    const icons = { ...FaIcons, ...AiIcons, ...BiIcons, ...GiIcons, ...BsIcons };
    const Icon = icons[iconName];

    return Icon ? <Icon /> : <FaIcons.FaHome />;
};

export default function SideBarLayout() {

    const [activeMenu, setActiveMenu] = useState('home');
    const [isCollapsed, setIsCollapsed] = useState(false);
    const menuData = useSelector((state) => state.menu.menuData);
    const [favorite, setFavorite] = useState([]);
    const dispatch = useDispatch();

    // 자식이 없는 부모 메뉴 필터링 함수 (재귀적)
    // isTopLevel: 최상위 레벨인지 여부 (최상위에서만 빈 children 필터링)
    const filterEmptyParents = (menuItems, isTopLevel = false) => {
        if (!Array.isArray(menuItems) || menuItems.length === 0) {
            return [];
        }

        return menuItems
            .map(item => {
                // children 속성이 있는 경우
                if (item.children && Array.isArray(item.children)) {
                    if (item.children.length > 0) {
                        // 자식이 있으면 재귀적으로 필터링 (하위 레벨로 전달)
                        const filteredChildren = filterEmptyParents(item.children, false);

                        // 필터링 후 자식이 있으면 반환
                        if (filteredChildren.length > 0) {
                            return { ...item, children: filteredChildren };
                        }
                        // 필터링 후 자식이 없으면 제거
                        return null;
                    } else {
                        // children이 빈 배열인 경우
                        if (isTopLevel) {
                            // 최상위 레벨의 빈 children → 필터링 (SPC 같은 경우)
                            return null;
                        } else {
                            // 하위 레벨의 빈 children → 유지 (실제 페이지)
                            return item;
                        }
                    }
                }
                // children 속성이 없으면 리프 노드로 유지
                return item;
            })
            .filter(item => item !== null); // null 항목 제거
    };

    // 필터링된 메뉴 데이터
    const filteredMenuData = React.useMemo(() => {
        return filterEmptyParents(menuData, true);
    }, [menuData]);

    useEffect(() => {
        getFavorite();
    }, []);

    const getFavorite = async () => {

        try {
            const response = await axiosInstance.post('/api/menu/favorite');
            setFavorite(response.data);
        } catch (error) {
            console.error('즐겨찾기 조회 실패:', error);
        }

    }

    const handleToggle = () => {
        setIsCollapsed(!isCollapsed);
    };

    const menuItemClick = (pageCode, pageName, parentPath = null, pageIdx = null) => {
        const isProductPlanPage = pageCode && (
            pageCode.includes('ProductPlan') ||
            ['ProductPlanDaily', 'ProductPlanWeekly', 'ProductPlanMonthly', 'ProductPlanAnnually'].includes(pageCode)
        );

        // 고유  - 생산계획서는 parentPath 제외
        const uniqueKey = (parentPath && !isProductPlanPage) ? `${parentPath}_${pageCode}` : pageCode;
        setActiveMenu(uniqueKey);

        const displayTitle = (!isProductPlanPage && parentPath && parentPath.includes('본사')) ? `본사 - ${pageName}` :
                            (!isProductPlanPage && parentPath && parentPath.includes('연태')) ? `연태 - ${pageName}` : pageName;

        dispatch(addTab({ pageCode: uniqueKey, title: displayTitle, pageIdx }));
    }


    return (
        <Sidebar backgroundColor="#083580"
            width="15%"
            collapsed={isCollapsed}
            rootStyles={{
                color: 'white',
                height: '100vh',
                minHeight: '100vh',
                position: 'sticky',
                top: 0,
                alignSelf: 'stretch'
            }}>
            <div className="sidebar-header">
                <div className="logotext">
                    <img 
                        src={newLogo} 
                        alt="율도" 
                        className={`sidebar-logo ${isCollapsed ? 'collapsed' : ''}`}
                        onClick={() => menuItemClick('HomePage', '홈')}
                    />
                </div>
                <i className={`bx toggle ${isCollapsed ? 'bx-chevron-right' : 'bx-chevron-left'}`} onClick={handleToggle}></i>
            </div>
            <Menu iconShape="circle">
                <MenuItem active={activeMenu === 'HomePage'} onClick={() => menuItemClick('HomePage', '홈')} icon={<FaIcons.FaHome />}>홈</MenuItem>
                <SubMenu label='즐겨찾기' icon={<FaIcons.FaRegStar />}>
                    {favorite.map((child, index) => (
                        <SubMenuItem
                            key={index}
                            label={child.pageName}
                            icon={child.icon}
                            children={child.children}
                            pageCode={child.pageCode}
                            pageIdx={child.idx}
                            activeMenu={activeMenu}
                            menuItemClick={menuItemClick}
                        />
                    ))}
                </SubMenu>
                {
                    Array.isArray(filteredMenuData) && filteredMenuData.length > 0 ?
                        (
                            filteredMenuData.map((menu, index) => (
                                <SubMenuItem
                                    key={index}
                                    label={menu.pageName}
                                    icon={getIconComponent(menu.icon)}
                                    children={menu.children}
                                    pageCode={menu.pageCode}
                                    pageIdx={menu.idx}
                                    activeMenu={activeMenu}
                                    menuItemClick={menuItemClick}
                                >
                                </SubMenuItem>
                            ))
                        ) : null
                }
            </Menu>
        </Sidebar>
    );

}